export default __webpack_public_path__ + "static/media/Union.fdff013e.svg";